export default __webpack_public_path__ + "static/media/countdown.b99eb341.mp3";